import styled from 'styled-components';
import { tokens } from '@welbe/web-design-system';

export const Wrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
`;

export const Title = styled.div`
	font-style: normal;
	font-weight: 600;
	font-size: 16px;
	line-height: 22px;
	color: ${tokens.color_gray_dark};

	padding: 20px 0px;
`;

export const Description = styled.div`
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 22px;
	color: ${tokens.color_gray_dark};
	text-align: center;

	padding-bottom: 30px;
`;
